/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PaymentInfo } from "./PaymentInfo";
import { TransactionStatus } from "./TransactionStatus";
import { AmountEuroCents } from "./AmountEuroCents";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";
import { PatternString } from "@pagopa/ts-commons/lib/strings";

export enum SendPaymentResultOutcomeEnum {
  "OK" = "OK",

  "KO" = "KO",

  "NOT_RECEIVED" = "NOT_RECEIVED"
}

export enum ClientIdEnum {
  "IO" = "IO",

  "CHECKOUT" = "CHECKOUT",

  "CHECKOUT_CART" = "CHECKOUT_CART",

  "UNKNOWN" = "UNKNOWN"
}

/**
 * Transaction data returned when querying for an existing transaction
 */

/**
 * Node operation info
 */

/**
 * Error details for close payment result
 */

// required attributes
const TransactionInfoNodeInfoClosePaymentResultErrorR = t.interface({});

// optional attributes
const TransactionInfoNodeInfoClosePaymentResultErrorO = t.partial({
  statusCode: t.number,

  description: t.string
});

export const TransactionInfoNodeInfoClosePaymentResultError = t.intersection(
  [
    TransactionInfoNodeInfoClosePaymentResultErrorR,
    TransactionInfoNodeInfoClosePaymentResultErrorO
  ],
  "TransactionInfoNodeInfoClosePaymentResultError"
);

export type TransactionInfoNodeInfoClosePaymentResultError = t.TypeOf<
  typeof TransactionInfoNodeInfoClosePaymentResultError
>;

// required attributes
const TransactionInfoNodeInfoR = t.interface({});

// optional attributes
const TransactionInfoNodeInfoO = t.partial({
  closePaymentResultError: TransactionInfoNodeInfoClosePaymentResultError,

  sendPaymentResultOutcome: enumType<SendPaymentResultOutcomeEnum>(
    SendPaymentResultOutcomeEnum,
    "sendPaymentResultOutcome"
  )
});

export const TransactionInfoNodeInfo = t.intersection(
  [TransactionInfoNodeInfoR, TransactionInfoNodeInfoO],
  "TransactionInfoNodeInfo"
);

export type TransactionInfoNodeInfo = t.TypeOf<typeof TransactionInfoNodeInfo>;

/**
 * Gateway infos
 */

// required attributes
const TransactionInfoGatewayInfoR = t.interface({});

// optional attributes
const TransactionInfoGatewayInfoO = t.partial({
  gateway: PatternString("NPG|REDIRECT"),

  authorizationStatus: t.string,

  authorizationCode: t.string,

  errorCode: t.string
});

export const TransactionInfoGatewayInfo = t.intersection(
  [TransactionInfoGatewayInfoR, TransactionInfoGatewayInfoO],
  "TransactionInfoGatewayInfo"
);

export type TransactionInfoGatewayInfo = t.TypeOf<
  typeof TransactionInfoGatewayInfo
>;

// required attributes
const TransactionInfoR = t.interface({
  transactionId: t.string,

  payments: t.readonlyArray(PaymentInfo, "array of PaymentInfo"),

  status: TransactionStatus
});

// optional attributes
const TransactionInfoO = t.partial({
  feeTotal: AmountEuroCents,

  idCart: t.string,

  clientId: enumType<ClientIdEnum>(ClientIdEnum, "clientId"),

  nodeInfo: TransactionInfoNodeInfo,

  gatewayInfo: TransactionInfoGatewayInfo
});

export const TransactionInfo = t.intersection(
  [TransactionInfoR, TransactionInfoO],
  "TransactionInfo"
);

export type TransactionInfo = t.TypeOf<typeof TransactionInfo>;
